/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Loader, Pagination, Button, Segment, Icon } from "semantic-ui-react";
import { size, map } from "lodash";
import { EventItem } from "../EventItem";
import { EventListItem } from "../EventListItem";
import { EventGrid } from "../EventGrid";
import { Event } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./ListEvents.scss";

const eventController = new Event();

export function ListEvents(props) {
  const {
    reload,
    onReload,
    filters = {},
    currentPage = 1,
    setCurrentPage,
    viewMode = "grid",
  } = props;
  const [events, setEvents] = useState(null);
  const [pagination, setPagination] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setEvents(null);
        const cleanFilters = {};
        Object.keys(filters).forEach((key) => {
          if (
            filters[key] !== "" &&
            filters[key] !== null &&
            filters[key] !== undefined
          ) {
            cleanFilters[key] = filters[key];
          }
        });

        const response = await eventController.getEvents(
          accessToken,
          cleanFilters,
          currentPage,
          12
        );
        setEvents(response.data);
        setPagination(response.pagination);
      } catch (error) {
        console.error("Error loading events:", error);
        setEvents([]);
      }
    })();
  }, [currentPage, reload, filters, accessToken]);

  const changePage = (_, data) => {
    if (setCurrentPage) {
      setCurrentPage(data.activePage);
    }
  };

  if (events === null) return <Loader active inline="centered" />;

  return (
    <div className="list-events">
      <div className="list-events__results">
        {size(events) === 0 ? (
          <Segment className="list-events__empty">
            <Icon name="calendar times outline" size="huge" />
            <p>No se encontraron eventos</p>
          </Segment>
        ) : (
          <>
            {viewMode === "grid" ? (
              <EventGrid events={events} onReload={onReload} />
            ) : (
              <div className="list-events__list">
                {map(events, (event) => (
                  <EventListItem
                    key={event.id}
                    event={event}
                    onReload={onReload}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {pagination && pagination.totalPages > 1 && (
        <div className="list-events__pagination">
          {pagination && events && (
            <span className="list-events__pagination-info">
              Mostrando {(currentPage - 1) * 12 + 1}-
              {(currentPage - 1) * 12 + events.length} de{" "}
              {pagination.total || pagination.totalItems || 0} registros
            </span>
          )}
          <Pagination
            activePage={currentPage}
            totalPages={pagination.totalPages}
            onPageChange={changePage}
            ellipsisItem={{
              content: <Icon name="ellipsis horizontal" />,
              icon: true,
            }}
            firstItem={{
              content: <Icon name="angle double left" />,
              icon: true,
              disabled: currentPage === 1,
            }}
            lastItem={{
              content: <Icon name="angle double right" />,
              icon: true,
              disabled: currentPage === pagination.totalPages,
            }}
            prevItem={{
              content: <Icon name="angle left" />,
              icon: true,
              disabled: currentPage === 1,
            }}
            nextItem={{
              content: <Icon name="angle right" />,
              icon: true,
              disabled: currentPage === pagination.totalPages,
            }}
          />
        </div>
      )}
    </div>
  );
}
